import { HttpInterceptors } from "./http.interceptor";

export class SubscriptionsService extends HttpInterceptors {
	async listSubscriptions (filters) {
		const response = await this.axios.get("subscriptions/listSubscriptions", { params: { filters }});
		return response.data;
	}

	async getSubscriptionType () {
		const response = await this.axios.get("subscriptions/getSubscriptionType");
		return response.data;
	}

	async upsertSubscription (payload) {
		const response = await this.axios.post("subscriptions/upsertSubscription", payload);
		return response.data;
	}

	async executePay (payload) {
		const response = await this.axios.post("subscriptions/executePay", payload);
		return response.data;
	}

	async deleteSubscription (id) {
		const response = await this.axios.delete("subscriptions/deleteSubscription", { params: id });
		return response.data;
	}

	async listSubscriptionsType (filters) {
		const response = await this.axios.get("subscriptions/listSubscriptionsType", { params: { filters }});
		return response.data;
	}

	async upsertSubscriptionType (payload) {
		const response = await this.axios.post("subscriptions/upsertSubscriptionType", payload);
		return response.data;
	}

	async deleteSubscriptionType (id) {
		const response = await this.axios.delete("subscriptions/deleteSubscriptionType", { params: id });
		return response.data;
	}

	async releaseSubscription (payload) {
		const response = await this.axios.post("subscriptions/releaseSubscription", payload);
		return response.data;
	}

	async renewSubscription () {
		const response = await this.axios.post("/subscriptions/renewSubscription", {});
		return response.data;
	}
}
